import * as Yup from 'yup'
const ChecklistSchema = Yup.object({
    name:Yup.string().required('INPUT.VALIDATION.CUSTOMER.CHECKLIST.NAME'),
    type:Yup.string().required('INPUT.VALIDATION.CUSTOMER.CHECKLIST.TYPE'),
    // subtype:Yup.string().required('INPUT.VALIDATION.CUSTOMER.CHECKLIST.SUBTYPE')
})
export default ChecklistSchema;